<template>
	<div class="userInfo">
		<el-row align="middle" type="flex" class="mt30"> 
					<el-col :span="10"><div class="grid-content bg-purple jz"><img @click="updateAvatar" class="avatar" :src="avatarUrl" width="120" height="120"></div></el-col>
					<el-col :span="14" ><div class="grid-content bg-purple"></div></el-col>
		</el-row>
		<el-row align="middle" type="flex" > 
			<el-col :span="2"><div class="grid-content bg-purple"></div></el-col>
			<el-col :span="2"><div class="grid-content bg-purple">昵称</div></el-col>
			<el-col :span="6"><div class="grid-content bg-purple">{{nickName}} &nbsp;<img v-if="isShow" class="edit" @click="updateName" src="../assets/edit.png" ></div></el-col>
			<el-col :span="14" ><div class="grid-content bg-purple"></div></el-col>
		</el-row>
		<el-row align="middle" type="flex" > 
			<el-col :span="2"><div class="grid-content bg-purple"></div></el-col>
			<el-col :span="2"><div class="grid-content bg-purple">ID</div></el-col>
			<el-col :span="6"><div class="grid-content bg-purple">{{uid}}</div></el-col>
			<el-col :span="14" ><div class="grid-content bg-purple"></div></el-col>
		</el-row>
		<el-row align="middle" type="flex" > 
			<el-col :span="2"><div class="grid-content bg-purple"></div></el-col>
			<el-col :span="2"><div class="grid-content bg-purple">QQ</div></el-col>
			<el-col :span="6"><div class="grid-content bg-purple">{{QQ}} &nbsp;<img class="edit" @click="updateQQ" src="../assets/edit.png" ></div></el-col>
			<el-col :span="14" ><div class="grid-content bg-purple"></div></el-col>
		</el-row>

		<!-- 修改微信群二维码 -->
		<avatar :AvatarUrl="avatarUrl" :isShow="isShowAvatarWindow" @on-close="closeAvatarWindow" @on-success="successAvatarWindow"></avatar>
	</div>
</template>
<style scoped>
	.userInfo .jz{text-align: center;}
	.userInfo .mt30{margin-bottom:30px;}
	.userInfo .avatar{   border-radius: 120px; cursor: pointer;}
	.userInfo .edit{vertical-align: sub;cursor: pointer;}
</style>
<script>  
	import avatar from "../components/avatar"
	export default {
		name: 'userInfo',
		components: {avatar:avatar},
		methods: {
			updateName(){
				const self=this;
				var data= this.common.GetlocalStorage("UnLockUserData");
				var obj=JSON.parse(data);
				var userId=obj.UserID;
                this.$prompt('昵称（只能修改一次）', '修改昵称', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                inputPlaceholder:'请输入要修改的昵称',
                inputType:'text',
                inputPattern: /\S/,
				inputErrorMessage: '请输入要修改的昵称'
                }).then(({ value }) => {
				   
				    const loading = self.$loading(this.loading);
					self.http.ajaxGet("UpdateName?UserID="+userId+"&Name="+value,function(res){
						loading.close();
						if(res.ReturnCode == 1){
							self.$alert(res.Message, '温馨提示', {confirmButtonText: '确定'});
							self.nickName=value;
							obj.NickName=value;
							self.$store.dispatch('showActions',value);
							//判断昵称 
							if(self.nickName=='新手'+self.uid)
								self.isShow=true;
							else	
								self.isShow=false;
							self.common.SetlocalStorage(JSON.stringify(obj),"UnLockUserData");
						}else{
							self.$alert(res.Message, '温馨提示', {confirmButtonText: '确定'});
						}	
						},function(err){
							loading.close();
							self.$alert(err, '错误', {confirmButtonText: '确定'});
					})

                }).catch(() => {  });
			},
			updateQQ(){
				const self=this;
				var data= this.common.GetlocalStorage("UnLockUserData");
				var obj=JSON.parse(data);
				var userId=obj.UserID;
                this.$prompt('', '修改QQ', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                inputPlaceholder:'请输入要修改的QQ',
				inputType:'text',
				inputValue:self.QQ,
                inputPattern: /\S/,
				inputErrorMessage: '请输入要修改的QQ'
                }).then(({ value }) => {
				    const loading = self.$loading(this.loading);
					self.http.ajaxGet("UpdateQQ?UserID="+userId+"&QQ="+value,function(res){
						loading.close();
						if(res.ReturnCode == 1){
							self.$alert(res.Message, '温馨提示', {confirmButtonText: '确定'});
							self.QQ=value;
							obj.QQ=value;
							self.common.SetlocalStorage(JSON.stringify(obj),"UnLockUserData");
						}else{
							self.$alert(res.Message, '温馨提示', {confirmButtonText: '确定'});
						}	
						},function(err){
							loading.close();
							self.$alert(err, '错误', {confirmButtonText: '确定'});
					})

                }).catch(() => {  });
			},
			closeAvatarWindow(val){
				this.isShowAvatarWindow=val;
			},
			successAvatarWindow(val){
				this.avatarUrl=val;
			},
			updateAvatar()
			{
				this.isShowAvatarWindow=true;
			}
		},
		data() {
			return {
				nickName:'',
				uid:'',
				avatarUrl:'',
				QQ:'',
				isShow:true,
				isShowAvatarWindow:false
			}
		},
		computed:{
			pageSize(){
				return this.$store.getters.pageSize;
			},
			loading(){
				return this.$store.getters.loadingPara;
			}
		},
		mounted: function () {
			var data= this.common.GetlocalStorage("UnLockUserData");
			var obj=JSON.parse(data);
			this.nickName=obj.NickName;
			this.uid=obj.uid;
			this.avatarUrl=obj.AvatarUrl;
			this.QQ=obj.QQ;

			//判断昵称 
			if(this.nickName=='新手'+this.uid)
				this.isShow=true;
			else	
				this.isShow=false;
		}
	}
</script>



// WEBPACK FOOTER //
// src/views/userInfo.vue